import styled from "styled-components";
export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  font-weight: 400;
`;
